// extracted by mini-css-extract-plugin
export var dataSource = "b9_hY";
export var headerCell = "b9_ht";
export var lastUpdatedLabel = "b9_hW";
export var lastUpdatedRow = "b9_hV";
export var lastUpdatedTag = "b9_hT";
export var lastUpdatedValue = "b9_hX";
export var loanOptionCell = "b9_hQ";
export var loanTypeVariant = "b9_hR";
export var rateCell = "b9_hS";
export var table = "b9_c";
export var tableHeader = "b9_hs";
export var tableRow = "b9_hP";
export var tableWrapper = "b9_hN";